import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { BsModalService } from 'ngx-bootstrap';
import { first } from 'rxjs/operators';
import { InventoryIdenty } from '../../../core/model/inventories';
import { AzDetail } from '../../../core/model/inventory-detail/az-detail';
import { ExpedienteDetail } from '../../../core/model/inventory-detail/expediente-detail';
import { Page } from '../../../core/model/page';
import { ResizedEvent } from '../../../core/model/resized-event';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { InventariosService } from '../../../core/services/inventarios.service';
import { ShoppingElementsService } from '../../../core/services/shopping-elements.service';
import { ModalShowTextComponent } from '../../../utils/modal-show-text/modal-show-text.component';
@Component({
  selector: 'app-az-detalle',
  templateUrl: './az-detalle.component.html',
  styleUrls: ['./az-detalle.component.css']
})
export class AzDetalleComponent implements OnInit {

  @ViewChild('table') table: DatatableComponent;
  idAz: string;
  azSeleccionado: AzDetail;
  cliente: string;
  expedientes: ExpedienteDetail[];
  page = new Page();
  loading = false;

  userIsPermissionPartialLoan: boolean;

  // ngx-datatable options
  customMessages = {
    emptyMessage: 'No hay unidades documentales',
    totalMessage: 'Total',
    selectedMessage: 'Selección'
  };
  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: 'fa fa-sort-desc',
    pagerLeftArrow: 'fa fa-chevron-left',
    pagerRightArrow: 'fa fa-chevron-right',
    pagerPrevious: 'fa fa-step-backward',
    pagerNext: 'fa fa-step-forward'
  };

  private isModalEdit: boolean;
  private obsPartial = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthenticationService,
    private inventarioService: InventariosService,
    private modalService: BsModalService,
    private shoppingCartElementsService: ShoppingElementsService
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.idAz = params.get('id');
      // this.azSeleccionado = (<AZ>JSON.parse(localStorage.getItem(`AZ_${this.idAz}`)));
      this.inventarioService.getAzById(this.idAz).pipe(first()).subscribe((azDetail: AzDetail) => {
        const azSeleccionado = this.shoppingCartElementsService.getRecordWithCartInformation(azDetail);
        this.azSeleccionado = azSeleccionado as AzDetail;
      });
      this.cliente = this.authService.getClienteName();
    });
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.userIsPermissionPartialLoan = this.authService.permisosPartialLoan;
  }


  changeRowsTable() {
    this.page.pageNumber = 0;
    this.table.recalculate();
    this.getUnidadesDocumentales();
  }

  getUnidadesDocumentales() {
    const inicio = this.page.size * this.page.pageNumber;
    const fin = inicio + this.page.size;
    this.getPaginationData(inicio, fin);
  }

  private getPaginationData(inicio: number, fin: number) {
    this.loading = true;
    this.inventarioService.getExpedientesOfAz(this.azSeleccionado.id, inicio, fin)
      .subscribe((result: any) => {
        if (result.DOCUMENTOS) {
          this.expedientes = result.DOCUMENTOS.map((documento: any) => ExpedienteDetail.toModel(JSON.stringify(documento)));
        }
        this.page.totalElements = result.CONTADOR;
        this.loading = false;
      },
        error => {
          this.loading = false;
        });
  }

  onResizedTable(event: ResizedEvent) {
    if (this.table) {
      setTimeout(() => {
        this.table.recalculate();
        window.dispatchEvent(new Event('resize'));
      }, (50));
    }
  }

  changePage(pageInfo: any) {
    this.page.pageNumber = pageInfo.offset;
    this.getUnidadesDocumentales();
  }

  loadInventoryRecord(idExpediente: string) {
    this.inventarioService.goToRecordDetailById(idExpediente);
  }

  goToContainer(id: number) {
    this.inventarioService.goToContainers(id);
  }
  openObsPartialModal() {
    this.isModalEdit = false;
    this.showModalText();
  }

  private showModalText() {
    const modalTitle = !this.isModalEdit ? 'inventory.tittleObsPartial' : 'inventory.tittleEditObsPartial';
    const modalTextConfirm = !this.isModalEdit ? 'inventory.createPartialLoan' : 'inventory.editPartialLoanButton';
    const modal = this.modalService.show(ModalShowTextComponent);
    (<ModalShowTextComponent>modal.content).showTextModal(
      modalTitle,
      this.obsPartial,
      modalTextConfirm
    );
    (<ModalShowTextComponent>modal.content).onClose.subscribe((result: string) => {
      if (result && result != '') {
        this.obsPartial = result;
        this.createPartialLoan();
      }
      this.closeModal();
    });
  }

  closeModal() {
    this.obsPartial = undefined;
    this.isModalEdit = false;
  }

  createPartialLoan() {
    const containerDetails: InventoryIdenty = this.shoppingCartElementsService
      .addOrReplacePartialLoanElement(this.azSeleccionado, this.obsPartial);
    this.azSeleccionado.shoppingCart = containerDetails.shoppingCart;
    this.closeModal();
  }

  createLoan() {
    const containerDetails: InventoryIdenty = this.shoppingCartElementsService.addOrReplaceLoanElement(this.azSeleccionado);
    this.azSeleccionado.shoppingCart = containerDetails.shoppingCart;
  }

}
